import { SignupChargeDetails } from "features/types";

const env = location.host.split(".")[1]; // stage, demo or go
export const planIdProperty = env === "demo" ? "demoId" : "prodId";

export const getSinglePrice = (charge: SignupChargeDetails) => {
  const { signupFees, totalBasePrice } = charge;
  const totalFees =
    signupFees?.reduce((acc, fee) => acc + Number(fee.feeAmount), 0) || 0;
  return Number(totalBasePrice) + totalFees;
};

export const getRecurringPrice = (charge: SignupChargeDetails) => {
  const { recurringFees, recurringCharge } = charge;
  const totalFees =
    recurringFees?.reduce((acc, fee) => acc + Number(fee.feeAmount), 0) || 0;
  return Number(recurringCharge) + totalFees;
};
